import { MenuItem, Select, SelectChangeEvent, styled, Typography } from '@mui/material';
import { EconsultUser, EconsultUtils, NameUtils } from '@oh-vcp/components-common';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

const menuWidth = EconsultUtils.isMobileDevice() ? '65%' : 'inherit';
const SelectContainer = styled(Select)({
  height: 30,
  width: EconsultUtils.isMobileDevice() ? '100%' : '94.5%',
  paddingTop: 5,
  '& .MuiSelect-icon': {
    backgroundColor: 'white',
    right: '0px'
  }
});

interface EconsultDelegatorSelectorProps {
  userId: string;
  onUserSelected: (userId: string) => void;
  options: EconsultUser[];
  hideOutline?: boolean;
}

const EconsultDelegatorSelector: FC<EconsultDelegatorSelectorProps> = ({
  userId,
  onUserSelected,
  options,
  hideOutline
}) => {
  const { t } = useTranslation();
  const [myHeight, setMyHeight] = useState<number>(EconsultUtils.isMobileDevice() ? 60 : 30);
  const handleChange = (e: SelectChangeEvent<unknown>) => {
    setMyHeight(30);
    if (EconsultUtils.isMobileDevice()) {
      const targetUserId = e.target.value as number;
      const ou = options.find((usr) => usr.userId === targetUserId);
      if (ou) {
        const consultantSelected = NameUtils.makeName(
          ou.lastName || '',
          ou.firstName,
          ou.salutation,
          ou.specialty,
          null,
          null
        );
        if (consultantSelected && consultantSelected.length > 30) {
          setMyHeight(60);
        }
      }
    }
    onUserSelected(e.target.value as string);
  };
  if (options.length <= 1) {
    return null;
  }
  return (
    <SelectContainer
      title={t('Case.selector.selectDelegate') as string}
      MenuProps={{
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left'
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'left'
        },
        slotProps: {
          paper: {
            sx: {
              width: menuWidth
            }
          }
        }
      }}
      sx={{
        '.MuiTypography-root': {
          color: hideOutline ? 'primary.main' : ''
        }
      }}
      value={userId}
      onChange={handleChange}
      disableUnderline={hideOutline}
      variant={hideOutline ? 'standard' : 'outlined'}
      style={{ height: myHeight }}>
      {options.map((o) => (
        <MenuItem
          value={o.userId}
          key={o.userId}
          sx={{
            '&:hover': userId === o.userId?.toString() ? { color: 'initial' } : {},
            '&.Mui-selected:hover': { color: 'black' }
          }}>
          {EconsultUtils.isMobileDevice() ? (
            <Typography
              variant="body2"
              noWrap={false}
              style={{ wordBreak: 'break-word', whiteSpace: 'normal', width: '100%' }}>
              {NameUtils.makeName(
                o.lastName || '',
                o.firstName,
                o.salutation,
                o.specialty,
                null,
                null
              )}
            </Typography>
          ) : (
            <Typography variant="body2">
              {NameUtils.makeName(
                o.lastName || '',
                o.firstName,
                o.salutation,
                o.specialty,
                null,
                null
              )}
            </Typography>
          )}
        </MenuItem>
      ))}
    </SelectContainer>
  );
};

export default EconsultDelegatorSelector;
